/* ---------------------------------------------------------------------------
   Jabree — Belt pack builder (mix and match).

   The tiers are quantity discounts on the Belts collection, so a pack can mix
   styles, colorways and lengths freely. One slot at a time is expanded; a filled
   slot collapses to a summary row so a 3-pack still fits a phone screen.

   Stock is checked per VARIANT and across slots, because two slots can land on
   the same variant and there is often only one or two of a colorway left.
   --------------------------------------------------------------------------- */
(function () {
  var root = document.getElementById('jbp');
  var dataEl = document.getElementById('jbp-data');
  if (!root || !dataEl || root.__jbpInit) return;
  root.__jbpInit = 1;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!DATA || !DATA.styles || !DATA.styles.length) return;

  var TIERS = String(DATA.tiers || '').split(',').map(function (t) {
    var p = t.split('|');
    return { qty: parseInt(p[0], 10), cents: parseInt(p[1], 10) };
  }).filter(function (t) { return t.qty > 0; });
  if (!TIERS.length) return;

  var els = {
    slots: root.querySelector('[data-jbp-slots]'),
    tiers: root.querySelector('[data-jbp-tiers]'),
    title: root.querySelector('[data-jbp-title]'),
    sub: root.querySelector('[data-jbp-sub]'),
    was: root.querySelector('[data-jbp-was]'),
    now: root.querySelector('[data-jbp-now]'),
    save: root.querySelector('[data-jbp-save]'),
    add: root.querySelector('[data-jbp-add]'),
    note: root.querySelector('[data-jbp-note]')
  };

  var slotCount = TIERS[TIERS.length - 1].qty;
  var slots = [];      // { style, color, size }
  var openSlot = 0;

  function money(cents) {
    var p = window.jabMoneyParts || { pre: '$', post: '' };
    return p.pre + (cents / 100).toFixed(2).replace(/\.00$/, '') + p.post;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function styleOf(handle) {
    for (var i = 0; i < DATA.styles.length; i++) if (DATA.styles[i].handle === handle) return DATA.styles[i];
    return null;
  }
  function variantOf(st, color, size) {
    if (!st) return null;
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      if (st.colorPos > -1 && v.options[st.colorPos] !== color) continue;
      if (st.sizePos > -1 && v.options[st.sizePos] !== size) continue;
      return v;
    }
    return null;
  }
  function stockOf(v) {
    if (!v) return 0;
    if (!v.managed || v.policy === 'continue') return Infinity;
    return typeof v.qty === 'number' ? v.qty : 0;
  }
  /* What is ALREADY in the shopper's cart, variant id -> quantity. Without this the
     builder offers a colorway the cart has already taken the last of, and Shopify
     rejects the WHOLE multi-add with 422 "maximum quantity already in your cart",
     which looked like a generic breakage. Refreshed every time the popup opens. */
  var IN_CART = {};
  function freeStock(v) {
    var s = stockOf(v);
    return s === Infinity ? Infinity : Math.max(0, s - (IN_CART[v.id] || 0));
  }
  function loadCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        IN_CART = {};
        if (c && c.items) c.items.forEach(function (it) {
          IN_CART[it.variant_id] = (IN_CART[it.variant_id] || 0) + it.quantity;
        });
        prune();
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }
  /* Drop any slot choice the refreshed cart just made impossible. */
  function prune() {
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      if (!s || !s.color) continue;
      var st = styleOf(s.style);
      if (!st) continue;
      if (s.size && !sizeHasStock(st, s.color, s.size, i)) s.size = null;
      if (!colorHasStock(st, s.color, i)) { s.color = null; s.size = null; }
    }
  }
  /* How many slots (other than `except`) already claim this exact variant. */
  function claimed(variantId, except) {
    var n = 0;
    slots.forEach(function (s, i) {
      if (i === except) return;
      var st = styleOf(s.style);
      var v = variantOf(st, s.color, s.size);
      if (v && v.id === variantId) n++;
    });
    return n;
  }
  function colorHasStock(st, color, except) {
    return st.variants.some(function (v) {
      if (st.colorPos > -1 && v.options[st.colorPos] !== color) return false;
      return v.available && freeStock(v) > claimed(v.id, except);
    });
  }
  function sizeHasStock(st, color, size, except) {
    var v = variantOf(st, color, size);
    return !!v && v.available && freeStock(v) > claimed(v.id, except);
  }
  function slotVariant(i) {
    var s = slots[i];
    if (!s || !s.style || !s.color || !s.size) return null;
    return variantOf(styleOf(s.style), s.color, s.size);
  }
  function filledCount() {
    var n = 0;
    for (var i = 0; i < slotCount; i++) if (i < activeQty() && slotVariant(i)) n++;
    return n;
  }

  var activeTierIdx = TIERS.length - 1;
  function activeQty() { return TIERS[activeTierIdx].qty; }
  function activeCents() { return TIERS[activeTierIdx].cents; }

  /* ---------- render ---------- */
  function renderTiers() {
    if (!els.tiers) return;
    els.tiers.innerHTML = TIERS.map(function (t, i) {
      return '<button type="button" class="jbp__tier' + (i === activeTierIdx ? ' is-on' : '') +
        '" data-jbp-tier="' + i + '">' + t.qty + ' belts <b>' + money(t.cents) + '</b></button>';
    }).join('');
  }

  function slotSummary(i) {
    var s = slots[i], st = styleOf(s.style), v = slotVariant(i);
    var img = (v && v.img) || '';
    return '<div class="jbp__sum2">' +
      (img ? '<img src="' + esc(img) + '" alt="" width="40" height="40" loading="lazy">' : '<span class="jbp__ph"></span>') +
      '<span class="jbp__sumTxt"><b>' + esc(st.title) + '</b><span>' + esc(s.color) + ' · ' + esc(s.size) + '</span></span>' +
      '<span class="jbp__change">Change</span></div>';
  }

  function renderSlots() {
    var qty = activeQty();
    var html = '';
    for (var i = 0; i < qty; i++) {
      var s = slots[i];
      var done = !!slotVariant(i);
      var isOpen = i === openSlot;
      html += '<div class="jbp__slot' + (isOpen ? ' is-open' : '') + (done ? ' is-done' : '') + '" data-jbp-slot="' + i + '">';
      html += '<button type="button" class="jbp__slotHead" data-jbp-slothead="' + i + '">' +
        '<span class="jbp__slotN">' + (i + 1) + '</span>' +
        (done && !isOpen ? slotSummary(i) : '<span class="jbp__slotLbl">' + (done ? 'Belt ' + (i + 1) : 'Pick belt ' + (i + 1)) + '</span>') +
        '</button>';

      if (isOpen) {
        html += '<div class="jbp__slotBody">';

        /* style */
        html += '<p class="jbp__lbl">Style</p><div class="jbp__styles">';
        /* Names, not thumbnails. A row of belt photos sitting directly above a row of
           colour photos reads as one grid and hides which choice is which. The colour
           row is the one that has to be seen, so it gets the room. */
        DATA.styles.forEach(function (st) {
          var on = s.style === st.handle;
          html += '<button type="button" class="jbp__style' + (on ? ' is-on' : '') + '" data-jbp-style="' + esc(st.handle) + '">' +
            esc(st.title.replace(/ Belt$/, '')) + '</button>';
        });
        html += '</div>';

        var st2 = styleOf(s.style);
        if (st2) {
          /* colour */
          html += '<p class="jbp__lbl">Color<span class="jbp__lblVal">' + (s.color ? esc(s.color) : '') + '</span></p><div class="jbp__colors">';
          st2.colors.forEach(function (c) {
            var ok = colorHasStock(st2, c.v, i);
            var on = s.color === c.v;
            html += '<button type="button" class="jbp__color' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '"' +
              (ok ? '' : ' disabled') + ' data-jbp-color="' + esc(c.v) + '" title="' + esc(c.v) + (ok ? '' : ' (sold out)') + '" aria-label="' + esc(c.v) + '">' +
              (c.img ? '<img src="' + esc(c.img) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</button>';
          });
          html += '</div>';

          /* length */
          html += '<p class="jbp__lbl">' + esc(st2.sizeName) + '</p><div class="jbp__sizes">';
          st2.sizes.forEach(function (sv) {
            var ok = s.color ? sizeHasStock(st2, s.color, sv, i) : false;
            var on = s.size === sv;
            html += '<button type="button" class="jbp__size' + (on ? ' is-on' : '') + '"' + (ok ? '' : ' disabled') +
              ' data-jbp-size="' + esc(sv) + '">' + esc(sv) + '</button>';
          });
          html += '</div>';
        }
        html += '</div>';
      }
      html += '</div>';
    }
    els.slots.innerHTML = html;
  }

  function renderFoot() {
    var qty = activeQty(), n = filledCount();
    var full = 0;
    for (var i = 0; i < qty; i++) { var v = slotVariant(i); if (v) full += v.price; }
    var ready = n === qty;

    if (ready) {
      els.was.textContent = money(full);
      els.now.textContent = money(activeCents());
      els.save.textContent = 'Save ' + money(full - activeCents());
      els.save.hidden = false;
      els.add.disabled = false;
      els.add.textContent = 'Add ' + qty + ' to cart · ' + money(activeCents());
      els.note.textContent = 'The tier price applies in your cart.';
      els.note.className = 'jbp__note';
    } else {
      els.was.textContent = '';
      els.now.textContent = '';
      els.save.textContent = '';
      els.save.hidden = true;
      els.add.disabled = true;
      els.add.textContent = 'Add ' + qty + ' to cart';
      els.note.textContent = (qty - n) + ' more to pick.';
      els.note.className = 'jbp__note';
    }
    if (els.sub) els.sub.textContent = 'Mix any styles, colors and lengths.';
    if (els.title) els.title.textContent = 'Build your ' + qty + '-pack, ' + money(activeCents());
  }

  function render() { renderTiers(); renderSlots(); renderFoot(); }

  /* ---------- interaction ---------- */
  els.slots.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var head = t.closest('[data-jbp-slothead]');
    if (head) { openSlot = parseInt(head.getAttribute('data-jbp-slothead'), 10); render(); return; }

    var slotEl = t.closest('[data-jbp-slot]');
    if (!slotEl) return;
    var i = parseInt(slotEl.getAttribute('data-jbp-slot'), 10);

    var sBtn = t.closest('[data-jbp-style]');
    if (sBtn) {
      var h = sBtn.getAttribute('data-jbp-style');
      if (slots[i].style !== h) { slots[i].style = h; slots[i].color = null; slots[i].size = null; }
      render(); return;
    }
    var cBtn = t.closest('[data-jbp-color]');
    if (cBtn && !cBtn.disabled) {
      slots[i].color = cBtn.getAttribute('data-jbp-color');
      slots[i].size = null;
      render(); return;
    }
    var zBtn = t.closest('[data-jbp-size]');
    if (zBtn && !zBtn.disabled) {
      slots[i].size = zBtn.getAttribute('data-jbp-size');
      /* Jump to the next unfilled slot so a 3-pack is three taps per belt, not a hunt. */
      var next = -1;
      for (var k = 0; k < activeQty(); k++) if (!slotVariant(k)) { next = k; break; }
      openSlot = next === -1 ? i : next;
      render(); return;
    }
  });

  els.tiers.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-jbp-tier]') : null;
    if (!b) return;
    activeTierIdx = parseInt(b.getAttribute('data-jbp-tier'), 10);
    var next = -1;
    for (var k = 0; k < activeQty(); k++) if (!slotVariant(k)) { next = k; break; }
    openSlot = next === -1 ? 0 : next;
    render();
  });

  els.add.addEventListener('click', function () {
    var qty = activeQty();
    var byId = {};
    for (var i = 0; i < qty; i++) {
      var v = slotVariant(i);
      if (!v) return;
      byId[v.id] = (byId[v.id] || 0) + 1;
    }
    var items = Object.keys(byId).map(function (id) { return { id: parseInt(id, 10), quantity: byId[id] }; });
    els.add.disabled = true;
    els.add.textContent = 'Adding…';
    /* Plain fetch on purpose: jab-cart monkeypatches window.fetch for /cart/add and
       opens the side cart, which is where the tier discount becomes visible. */
    function post() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }
    /* Shopify throttles bursts of cart calls (429) and occasionally 5xxs. Those are
       transient and have nothing to do with the pack, so retry once quietly rather
       than telling the shopper their pack failed. A 422 is a real answer: no retry. */
    post().then(function (r) {
      if (r.status === 429 || r.status >= 500) {
        return new Promise(function (res) { setTimeout(res, 1200); }).then(post);
      }
      return r;
    }).then(function (r) {
      if (r.ok) return r.json();
      /* Shopify explains itself in the 422 body (almost always a sold-out colorway,
         or one the cart already holds the last of). Show that, don't swallow it. */
      return r.json().then(function (j) {
        throw { msg: (j && (j.description || j.message)) || '' };
      }, function () { throw { msg: '' }; });
    })
      .then(function () { close(); reset(); })
      .catch(function (e) {
        /* Re-read the cart so the offending colorway greys out instead of being
           offered again, then say what happened. */
        loadCart(function () {
          render();
          var msg = (e && e.msg) ? e.msg : 'Something went wrong adding to cart. Please try again.';
          if (e && e.msg) msg += ' Pick another colour or length.';
          els.note.textContent = msg;
          els.note.className = 'jbp__note jbp__note--err';
        });
      });
  });

  function reset() {
    slots = [];
    for (var i = 0; i < slotCount; i++) slots.push({ style: DATA.styles[0].handle, color: null, size: null });
    openSlot = 0;
  }
  reset();

  /* ---------- open / close ---------- */
  function open(qty, seed) {
    var idx = TIERS.length - 1;
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].qty === qty) idx = i;
    activeTierIdx = idx;
    reset();
    /* Seeded from the product page the shopper is already on: slot 1 is what they
       were looking at, so the popup continues their choice instead of restarting it. */
    if (seed && seed.style && styleOf(seed.style)) {
      slots[0].style = seed.style;
      if (seed.color) slots[0].color = seed.color;
      if (seed.size && seed.color && sizeHasStock(styleOf(seed.style), seed.color, seed.size, 0)) slots[0].size = seed.size;
      if (slotVariant(0)) openSlot = 1;
    }
    loadCart(render);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    render();
  }
  function close() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  root.addEventListener('click', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-jbp-close')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

  window.JabBeltPack = { open: open, close: close };
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-jbp-open]') : null;
    if (!b) return;
    e.preventDefault();
    open(parseInt(b.getAttribute('data-jbp-open'), 10) || slotCount, null);
  });
})();
